import { useContext, useState } from "react";
import { useLogging } from "../../../../../Shared/hooks/useLogging/useLogging";
import { BillingInformationContext } from "../../../BillingInformationContext";
import { getGiftCardByNumber, getPaymentMethods } from "./PaymentMethodFetch-utils";
export const usePaymentMethodFetch = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState();
    const { setCustomerCreditCards, setPrimaryCreditCard, setCustomerGiftCards, setOldGiftCards, setEnableGiftCards } = useContext(BillingInformationContext);
    const { datadogLog } = useLogging();
    return {
        getPaymentMethods: getPaymentMethods(setLoading, setError, setCustomerCreditCards, setPrimaryCreditCard, setCustomerGiftCards, setOldGiftCards, setEnableGiftCards, datadogLog),
        getGiftCardByNumber: getGiftCardByNumber(datadogLog),
        loading,
        error,
    };
};
